/**
 * Shared layout tokens for the global top bar (GlobalTopBarChrome).
 * The bar is fixed at the top of the viewport; page shells reserve clearance below it.
 */

/** MUI dense toolbar height for GlobalTopBarChrome. */
export const APP_TOP_BAR_HEIGHT_PX = 56;

/** Identity chip / avatar in the top bar. */
export const APP_TOP_BAR_AUTH_CHIP_PX = 36;

/** Apps and help icons — sized relative to the identity chip. */
export const APP_TOP_BAR_ACTION_ICON_PX = APP_TOP_BAR_AUTH_CHIP_PX * 0.68 * 1.2;

/** Minimum click target for top-bar icon actions. */
export const APP_TOP_BAR_ACTION_HIT_PX = 40;

/** Above dashboard drawers/banners; below MUI modal layer (1300). */
export const APP_TOP_BAR_Z_INDEX = 1290;

/** Fixed dashboard status alerts — below GlobalTopBarChrome, above page content. */
export const dashboardStatusBannerFixedSx = {
  position: 'fixed',
  top: `${APP_TOP_BAR_HEIGHT_PX}px`,
  left: { xs: 0, sm: '300px' },
  right: 0,
  width: { xs: '100%', sm: 'calc(100% - 300px)' },
  zIndex: 1200,
  borderRadius: 0,
};

/** @deprecated Fixed overlay removed; kept for callers migrating gradually. */
export const APP_TOP_BAR_RIGHT_INSET_PX = 208;

/** @deprecated */
export const APP_TOP_BAR_CLUSTER_WIDTH_PX = 320;

/** @deprecated */
export const APP_TOP_BAR_ADMIN_LINKS_WIDTH_PX = 300;

/** @deprecated Use normal page padding; chrome is no longer fixed. */
export const APP_TOP_BAR_PAGE_PADDING_RIGHT = `${APP_TOP_BAR_CLUSTER_WIDTH_PX}px`;

/** @deprecated Notification bell is in GlobalTopBarChrome. */
export const APP_TOP_BAR_NOTIFICATION_BELL_RIGHT = '16px';

/** @deprecated */
export const APP_TOP_BAR_ADMIN_PAGE_PADDING_RIGHT = `${APP_TOP_BAR_ADMIN_LINKS_WIDTH_PX}px`;

/** Standard page band below the global top bar. */
export const appTopBarClearanceSx = {
  boxSizing: 'border-box',
  width: '100%',
  px: { xs: 2, sm: 3 },
  py: 2,
};

/** Full-width one-row toolbar (back links, local admin actions). */
export const appTopBarToolbarSx = {
  boxSizing: 'border-box',
  width: '100%',
  px: 2,
  py: 1,
};

// Backward-compatible aliases for DecisionPoint imports.
export const DP_TOP_BAR_RIGHT_INSET_PX = APP_TOP_BAR_RIGHT_INSET_PX;
export const DP_TOP_BAR_CLUSTER_WIDTH_PX = APP_TOP_BAR_CLUSTER_WIDTH_PX;
export const DP_TOP_BAR_ADMIN_LINKS_WIDTH_PX = APP_TOP_BAR_ADMIN_LINKS_WIDTH_PX;
export const DP_TOP_BAR_PAGE_PADDING_RIGHT = APP_TOP_BAR_PAGE_PADDING_RIGHT;
export const DP_TOP_BAR_ADMIN_PAGE_PADDING_RIGHT = APP_TOP_BAR_ADMIN_PAGE_PADDING_RIGHT;
export const dpTopBarClearanceSx = appTopBarClearanceSx;
export const dpTopBarToolbarSx = appTopBarToolbarSx;
